export { BrandItem as default } from './BrandItem';
